export const PASSWORD_PATTERN =
	"^((?=.*?\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[-!@#$%^&*()_+|~=`{}\\[\\]:\";'<>?,.\\/])).{8,}$";

export const ZIP_CODE_PATTERN = "^\\d{5}(?:[\\s-]*\\d{4})?$";

export const POST_CODE_PATTERN =
	"^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]([\\s-]*)[0-9][ABCEGHJ-NPRSTV-Z][0-9]$";

export const DISPLAY_NAME_PATTERN = "^((?!@).)*$";

export const USER_NAME_PATTERN = "^([A-Za-z-_]*)$";
